import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function ChangePasswordPage() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [current, setCurrent] = useState("");
  const [np, setNp] = useState("");
  const [np2, setNp2] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    if (np !== np2) { setErr("Le password non coincidono"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: np });
      await refresh();
      nav("/");
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Errore");
    }
    setBusy(false);
  };

  return (
    <div className="ma-auth-wrap">
      <div className="ma-auth-card">
        <div className="ma-brand-lg">MASI<span>ADVICE</span></div>
        <div className="ma-brand-sub">Cambio password obbligatorio</div>
        <form onSubmit={submit} className="ma-form">
          <label className="ma-label">Password attuale</label>
          <input type="password" className="ma-input" value={current} onChange={e=>setCurrent(e.target.value)} required data-testid="cp-current"/>
          <label className="ma-label">Nuova password</label>
          <input type="password" className="ma-input" value={np} onChange={e=>setNp(e.target.value)} required data-testid="cp-new"/>
          <label className="ma-label">Conferma nuova password</label>
          <input type="password" className="ma-input" value={np2} onChange={e=>setNp2(e.target.value)} required data-testid="cp-new2"/>
          <div className="ma-hint">Min. 12 caratteri con maiuscola, minuscola, numero e carattere speciale.</div>
          {err && <div className="ma-error">{err}</div>}
          <button className="ma-btn-primary" disabled={busy} data-testid="cp-submit">{busy ? "Salvataggio…" : "Cambia password"}</button>
        </form>
      </div>
    </div>
  );
}
